import React, {useEffect, useState} from "react";

import {LoginColumn, LoginLeftColumn, LoginRightColumn, LogoImage, LogoWrapper,} from "./styles/loginStyles";
import Login from "./Login";
import ForgetPassword from "./ForgetPassword";
import {Validate} from "Framework/helpers/FormFieldHelper/FormFieldHelper";
import queryString from "query-string";
import ConfirmAndReset from "./ConfirmAndReset";

const LoginPage = ({Url, Image, Logo, LocalizedTexts, CurrentUser, Id: CurrentPageId, UseOpenID, Providers,}) => {
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [showLogin, setShowLogin] = useState(true);
    const [aft, setAft] = useState(null);
    const [resetUserId, setResetUserId] = useState("");
    const onChange = (value, type, errorFunc) => errorFunc(Validate(value, type));

    const toggleShowForgetPassword = (e) => {
        e.preventDefault();
        setShowForgetPassword(!showForgetPassword);
        setShowLogin(!showLogin);
    };


    useEffect(() => {

        const parsed = queryString.parse(location.search);
        const {change_guid, cleanCookies} = parsed;
        /*Fix for problem with long headers before login clean coockies*/
        if (!cleanCookies || cleanCookies === 'true') {
            fetch('/user/clearCookies', {
                method: "POST",
            })
                .then((response) => response.json())
                .then((data) => {
                        const location = window.location + '&cleanCookies=false';                       
                        window.location.href = location;
                    },
                    (error) => {
                    }
                );
        }

        let loginForm = document.getElementById("login-form");
        let antiForgeryTokenList = loginForm.querySelectorAll(
            "input[name=__RequestVerificationToken]"
        );
        if (antiForgeryTokenList !== undefined) {
            setAft(antiForgeryTokenList[0].value);
        }


        if (change_guid != undefined) {
            let headers = {};
            headers["Content-Type"] = "application/json";
            if (antiForgeryTokenList !== undefined) {
                headers["__RequestVerificationToken"] = antiForgeryTokenList[0].value;
                headers["RequestVerificationToken"] = antiForgeryTokenList[0].value;
            }

            fetch(`/user/check?guid=${change_guid}&currentPageId=${CurrentPageId}`, {
                method: "POST",
                headers: headers,
            })
                .then((response) => response.json())
                .then(
                    ({Status, Message, User}) => {
                        if (Status) {
                            setShowResetPassword(true);
                            setResetUserId(Message);
                        } else {
                            setShowLogin(true);
                        }
                    },
                    (error) => {
                    }
                );
        } else {
            setShowLogin(true);
        }


    }, []);


    useEffect(() => {
        if (showResetPassword) {
            setShowForgetPassword(false);
            setShowLogin(false);
        }
    }, [showResetPassword]);

    const getHeaders = () => {
        let headers = {};
        headers["__RequestVerificationToken"] = aft;
        headers["RequestVerificationToken"] = aft;
        headers["Content-Type"] = "application/json";
        return headers;
    };

    return (
        <LoginColumn smallrow>
            <LoginLeftColumn bgImage={Image}>
                <LogoWrapper>
                    <LogoImage src={Logo}/>
                </LogoWrapper>
                {showForgetPassword && (
                    <ForgetPassword
                        {...LocalizedTexts} CurrentPageId={CurrentPageId}
                        getHeaders={getHeaders}
                        validate={Validate}
                        onChange={onChange}
                        toggleShowForgetPassword={(e) => toggleShowForgetPassword(e)}
                    />
                )}
                {showLogin && (
                    <Login
                        CurrentPageId={CurrentPageId}
                        UseOpenID={UseOpenID}
                        Providers={Providers}
                        {...LocalizedTexts}
                        getHeaders={getHeaders}
                        validate={Validate}
                        onChange={onChange}
                        toggleShowForgetPassword={(e) => toggleShowForgetPassword(e)}
                    />
                )}
                {showResetPassword && (
                    <ConfirmAndReset
                        Reset={true}
                        aft={aft}
                        ResetUserId={resetUserId}
                        {...CurrentUser}
                        CurrentPageId={CurrentPageId}
                    />
                )}
                {/* <SecondaryButton
					onClick={e => {
						location.href = "/windows/login?returnUrl=/";
					}}
					width="100%"
					margin="3rem 0 0 0"
					padding=".5rem"
				>
					<ButtonText>Logga in med Windows</ButtonText>
				</SecondaryButton> */}
            </LoginLeftColumn>
            <LoginRightColumn
                bgImage={Image}
                backgroundImage="rgba(246, 148, 39, 0.7)"
            />
        </LoginColumn>
    );
};

export default LoginPage;
